import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { AppTable, AppTableColumn } from '../../table/appTable';
import Button from '../../buttons/button';
import { createLink } from '../utils/link-builder';

import { JobsActionButtonProps, JobsTableProps } from './job.types';

const ActionButtons = ({ original, onDelete }: JobsActionButtonProps) => {
  return (
    <>
      <Button
        text="Delete Job"
        icon={faTrash}
        slimButton
        onClick={e => {
          e.stopPropagation();
          onDelete(original.id);
        }}
      />
    </>
  );
};

export const JobsTable = ({ jobs, isLoading, onClickDelete }: JobsTableProps) => {
  const columns: AppTableColumn[] = [
    {
      Header: 'Type',
      id: 'jobType',
      accessor: 'jobType',
      width: 150,
    },
    {
      Header: 'School Name',
      id: 'schoolName',
      accessor: 'schoolName',
      width: 400,
    },
    {
      Header: 'Template',
      id: 'afterEffectsClipTemplate',
      accessor: 'afterEffectsClipTemplate.name',
      width: 200,
    },
    {
      Header: 'Progress',
      id: 'processingProgress',
      accessor: 'processingProgress',
      width: 100,
      Cell: ({ row }) => `${row.processingProgress}%`,
    },
    {
      Header: 'Hashtag',
      id: 'hashTag',
      accessor: 'hashTag',
      width: 150,
    },
    {
      Header: 'School Logo',
      id: 'schoolLogoImageUrl',
      accessor: 'schoolLogoImageUrl',
      width: 150,
      Cell: ({ row }) => createLink(row, 'schoolLogoImageUrl', 'View Logo'),
    },
    {
      Header: 'Primary Colour',
      id: 'firstColor',
      accessor: 'firstColor',
      width: 150,
    },
    {
      Header: 'Secondary Colour',
      id: 'secondColor',
      accessor: 'secondColor',
      width: 150,
    },
    {
      Header: 'Music',
      id: 'musicUrl',
      accessor: 'musicUrl',
      width: 150,
      Cell: ({ row }) => createLink(row, 'musicUrl', 'Preview Audio'),
    },
    {
      Header: 'Pre-Roll Video',
      id: 'preRollVideoUrl',
      accessor: 'preRollVideoUrl',
      width: 150,
      Cell: ({ row }) => createLink(row, 'preRollVideoUrl', 'View Video'),
    },
    {
      Header: 'Post-Roll Video',
      id: 'postRollVideoUrl',
      accessor: 'postRollVideoUrl',
      width: 150,
      Cell: ({ row }) => createLink(row, 'postRollVideoUrl', 'View Video'),
    },
    {
      Header: 'Participants Images?',
      id: 'includeParticipantsImages',
      accessor: 'includeParticipantsImages',
      width: 200,
      Cell: ({ row }) => (row.includeParticipantsImages ? 'Yes' : 'No'),
    },
    {
      Header: 'Participants Message Videos?',
      id: 'includeParticipantsMessageVideos',
      accessor: 'includeParticipantsMessageVideos',
      width: 200,
      Cell: ({ row }) => (row.includeParticipantsMessageVideos ? 'Yes' : 'No'),
    },
    {
      Header: 'Participants Live Videos?',
      id: 'includeParticipantsLiveVideos',
      accessor: 'includeParticipantsLiveVideos',
      width: 200,
      Cell: ({ row }) => (row.includeParticipantsLiveVideos ? 'Yes' : 'No'),
    },
    {
      Header: 'Actions',
      id: 'actions',
      accessor: 'actions',
      width: 300,
      Cell: ({ original }) => <ActionButtons original={original} onDelete={onClickDelete} />,
    },
  ];

  return (
    <>
      <AppTable
        columns={columns}
        tableName="job-management"
        data={jobs}
        defaultSorted={[{ id: 'index', desc: false }]}
        loading={isLoading}
      />
    </>
  );
};
